import React, { Component } from 'react'
import { AttendessMeetingTable, MeetingTable } from '../../components/Table/index'
import NoChat from '../../components/Chat/NoChat'

import { post, port, getImg } from '../../service/index'

import { connect } from 'react-redux'
import Loader from '../../components/Loader/Loader'

class ConferenceBody extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
    }
  }


  componentDidMount = async () => {
    try {
      const { token } = this.props.login.user
      const data = await post('/get_user_conference_read', { conference_id: this.props.conference_id }, token)
      const { result } = data
      //const user_id = data.result.user.user_id
      //console.log(user_id)

      this.setState({
        data: result.map(el => ({
          list: {
            name: el.name + ' ' + el.last_name,
            picture: el.user_id + '.png',
            position: el.position,
            token,
            currentPage: 0
          },
          phone: el.phone_num,
          enter: el.in_time,
          exit: el.out_time,

        })),
        loading: false
      })
    } catch (err) {
      console.log(err)
    }
  }

  setLoading = loading => this.setState({ loading })

  render() {
    const { title, detail, count_person } = this.props
    return (
      this.state.loading ? <Loader /> :
        <div className='container' >
          <div style={{ display: 'flex', }} >
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center', flexDirection: 'column' }} >
              <AttendessMeetingTable {...this.props} setLoading={this.setLoading} {...this.state} />
              {
                <span>
                  <p style={{ color: 'rgb(106, 213, 215)', fontSize: 20 }} >  {'จำนวนผู้เข้าร่วมการประชุม  ' + this.props.user_attend + ' คน'}</p>
                </span>
              }
              <MeetingTable {...this.props} />
            </div>

            <div style={{ display: 'flex', flex: 1 }} >
              <NoChat {...this.props} />
            </div>
          </div >
        </div>
    )
  }
}

const mapStateToProps = (state) => ({
  login: state.login
})

export default connect(mapStateToProps)(ConferenceBody)



// WEBPACK FOOTER //
// ./src/pages/Conference/ConferenceBody.js